var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-col",
        _vm._g(
          _vm._b(
            {
              staticClass: "drawing-item",
              class: { "active-from-item": _vm.activeIndex === _vm.index },
              attrs: { span: _vm.element.span },
              nativeOn: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.selectItem(_vm.element, _vm.index)
                }
              }
            },
            "el-col",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _vm.element.type === "input"
            ? [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.element.name, "label-width": "80px" } },
                  [
                    _c("el-input", {
                      style: { width: _vm.element.options.width },
                      attrs: { placeholder: _vm.element.options.placeholder },
                      model: {
                        value: _vm.element.options.defaultValue,
                        callback: function($$v) {
                          _vm.$set(_vm.element.options, "defaultValue", $$v)
                        },
                        expression: "element.options.defaultValue"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.element.type === "textarea"
            ? [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.element.name, "label-width": "80px" } },
                  [
                    _c("el-input", {
                      style: { width: _vm.element.options.width },
                      attrs: {
                        placeholder: _vm.element.options.placeholder,
                        type: _vm.element.type
                      },
                      model: {
                        value: _vm.element.options.defaultValue,
                        callback: function($$v) {
                          _vm.$set(_vm.element.options, "defaultValue", $$v)
                        },
                        expression: "element.options.defaultValue"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "drawing-item-delete",
              staticStyle: { visibility: "visibility" },
              attrs: { title: "删除" },
              on: {
                click: function($event) {
                  return _vm.delItem(_vm.element)
                }
              }
            },
            [_c("i", { staticClass: "el-icon-close" })]
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }